import { render, staticRenderFns } from "./v-login.vue?vue&type=template&id=20e3b19c&"
import script from "./v-login.vue?vue&type=script&lang=js&"
export * from "./v-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports